import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';

import {
  ConditionsReactivateGenreSimplifieDto,
  GenreSimplifieDto,
} from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateGenreSimplifie from './ConditionReactivateGenreSimplifie/ConditionReactivateGenreSimplifie';
import ModalDetails from './Modals/ModalDetails';
import ModalUpdate from './Modals/ModalUpdate';
import UsesGenreSimplifie from './UsesGenreSImplifie/UsesGenreSimplifie';
import { useChangeValidityGenreSimplifie } from './utils';

interface CellDetailsAndActionsProps {
  genreSimplifie: GenreSimplifieDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  genreSimplifie,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal();
  const modalModification = useModal();
  const modalDeprecate = useModal();

  const {
    submitReactivateGenreSimplifie,
    submitDeprecateGenreSimplifie,
    conditionsReactivateGenreSimplifie,
    getUsesGenreSimplifie,
  } = useChangeValidityGenreSimplifie();

  const conditionUnlock = (
    conditions?: ConditionsReactivateGenreSimplifieDto,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: 'Modifier',
      onClick: modalModification.open,
    },
    {
      key: '2',
      label: genreSimplifie.valid
        ? 'Désactiver le genre simplifié'
        : 'Activer le genre simplifié',
      onClick: modalDeprecate.open,
    },
  ];

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <ModalDetails
        genreSimplifie={genreSimplifie}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <AntdDropdown menu={{ items }} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>
      <ModalUpdate
        refreshDashboard={refreshDashboard}
        genreSimplifie={genreSimplifie}
        visible={modalModification.visible}
        close={modalModification.close}
      />

      {genreSimplifie.valid ? (
        <ModalDesactivation
          idCorrelation={genreSimplifie.idCorrelation}
          titleModal="Désactiver le genre simplifié"
          submitDeprecate={submitDeprecateGenreSimplifie}
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          usesRequest={getUsesGenreSimplifie}
          componentUses={UsesGenreSimplifie}
        />
      ) : (
        <ModalReactivation
          idCorrelation={genreSimplifie.idCorrelation}
          titleModal="Réactiver le genre simplifié"
          visible={modalDeprecate.visible}
          close={modalDeprecate.close}
          callAfterSubmit={refreshDashboard}
          conditionRequest={conditionsReactivateGenreSimplifie}
          componentConditions={ConditionReactivateGenreSimplifie}
          conditionUnlock={conditionUnlock}
          reactivateRequest={submitReactivateGenreSimplifie}
        />
      )}
    </>
  );
}

export default CellDetailsAndActions;
